import React from "react";
import { FaFilePdf } from "react-icons/fa";
import { TEMPLATE_FILE_TYPE } from "../constants/template";
import {
  FormInputContainer,
  FormInputLabel,
  RichTextContainer,
  WhatsAppButton,
  WhatsAppFooter,
  WhatsAppTemplate,
} from "../styles";

export const WhatsAppPreview = ({
  fileType,
  fileName,
  previewUrl,
  textWithFormat,
  footerMessage,
  buttons = [],
}) => {
  return (
    <FormInputContainer>
      <FormInputLabel>Vista previa</FormInputLabel>

      <WhatsAppTemplate>
        <div>
          {previewUrl && (
            <div
              style={{
                marginBottom: "1rem",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              {/* Image */}
              {fileType === TEMPLATE_FILE_TYPE.IMAGE && (
                <img
                  src={previewUrl}
                  alt="Preview"
                  style={{ width: "500px", height: "auto", display: "block" }}
                />
              )}

              {/* Video */}
              {fileType === TEMPLATE_FILE_TYPE.VIDEO && (
                <video
                  src={previewUrl}
                  controls
                  style={{ width: "500px", height: "auto", display: "block" }}
                />
              )}

              {/* PDF */}
              {fileType === TEMPLATE_FILE_TYPE.PDF && (
                <div
                  style={{
                    padding: "1rem",
                    backgroundColor: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    justifyContent: "center",
                  }}
                >
                  <FaFilePdf style={{ fontSize: "24px", color: "#e74c3c" }} />

                  <span style={{ fontSize: "0.875rem", color: "#333" }}>
                    {fileName}
                  </span>
                </div>
              )}
            </div>
          )}

          <RichTextContainer
            dangerouslySetInnerHTML={{ __html: textWithFormat }}
          />

          {footerMessage && <WhatsAppFooter>{footerMessage}</WhatsAppFooter>}

          {buttons.length > 0 && (
            <div
              style={{
                marginTop: "5px",
                backgroundColor: "white",
                borderRadius: "0 0 7.5px 7.5px",
                overflow: "hidden",
              }}
            >
              {buttons.map((btn, idx) => (
                <WhatsAppButton key={idx}>{btn.text}</WhatsAppButton>
              ))}
            </div>
          )}
        </div>
      </WhatsAppTemplate>
    </FormInputContainer>
  );
};
